import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../supabaseClient';
import { FaArrowLeft } from 'react-icons/fa';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/auth/reset-password`,
      });
      if (error) throw error;
      setMessage('Password reset email sent. Please check your inbox or spam folder. You may now close this page.');
    } catch (error) {
      setError(error.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col justify-center items-center p-4 sm:p-6 font-['Inter', sans-serif]">
      <div className="w-full max-w-md">
        <Link to="/auth" className="mb-4 inline-flex items-center text-neutral-900 hover:text-cranberry-700 transition-colors duration-300">
          <FaArrowLeft className="mr-2" />
          <span className="text-sm sm:text-base">Back to Login</span>
        </Link>
        <div className="bg-white rounded-xl shadow-lg p-4 sm:p-8 border-2 border-neutral-900">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-4 sm:mb-6 text-neutral-900">
            Forgot Password
          </h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-neutral-900">
                Email
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 block w-full px-4 py-2 rounded-xl border-2 border-neutral-900 focus:border-cranberry-700 focus:ring-1 focus:ring-cranberry-700 outline-none"
              />
            </div>
            {error && (
              <div className="text-sm text-red-600 bg-red-50 border-l-4 border-red-600 p-4 rounded-r-xl">
                {error}
              </div>
            )}
            {message && (
              <div className="text-sm text-emerald-600 bg-emerald-50 p-4 rounded-xl">
                {message}
              </div>
            )}
            <button
              type="submit"
              className="w-full flex justify-center py-2 px-6 rounded-xl text-white bg-cranberry-700 hover:bg-cranberry-600 transition-colors duration-300 font-medium border-2 border-neutral-900"
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Send Reset Email'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
